export default {
  getDetail: state => state.detail,
  getList: state => state.list,
  getCondition: state => state.condition,
  getPageInfo: state => state.pageInfo
};
